import { applyMiddleware, createStore } from 'redux';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from './reducers/index';
import env from '../env';

let history = createBrowserHistory({
  basename: env.publicUrl,
});

const middleware = [routerMiddleware(history), thunk];

const store = createStore(reducer, composeWithDevTools(applyMiddleware(...middleware)));

history = syncHistoryWithStore(history, store);

export { store, history };
